export default __webpack_public_path__ + "static/media/13_tag_restaurant.08aa3fc3.svg";